import React from 'react'
import { BreadcrumbView } from '../../../../../../context/breadcrumb.context'
import { CardFullHeightScrollY } from '../../../../../../shared/card/card-full-height-scroll-y'
import { IconEdit } from '../../../../../../shared/icon/icon'
import { useApiFormNodeLibrary } from '../../../../../../api-new/state/content'
import { useLoad } from '../../../../../../shared/hooks/load'
import { Form, FormSubmit, FormText } from '../../../../../../shared/form/form'
import { Card } from '../../../../../../shared/card/card'
import { LibraryMenu } from '../../common/menu/node-actions'
// import { NodeTags } from '../../common/shared/node-tags'
import { ThumnailAsset } from '../../common/thumbnail/thumbnail-asset'
import { useDataContext } from '../data-context'
import { PublishAssetList } from '../../common/publish/publish-asset-list'
import { Route } from 'react-router-dom/cjs/react-router-dom.min'

export const NodeLibraryEdit = ({ parentURL, nodeID }) => {
  const apiFormNodeLibrary = useApiFormNodeLibrary()

  const dataContext = useDataContext()

  useLoad(
    async () => {
      apiFormNodeLibrary.get(nodeID)
    },
    [nodeID]
  )

  const handleSubmit = async data => {
    await apiFormNodeLibrary.put(data.id, data)
    dataContext.reload()
  }

  const handleChange = () => dataContext.reload()

  const HeaderMenu = () => <LibraryMenu place="header" url={parentURL} />

  return (
    <React.Fragment>
      <BreadcrumbView text="edit" Icon={IconEdit}>
        <CardFullHeightScrollY title="edit" HeaderMenu={HeaderMenu}>
          <Card title="asset">
            <Form state={apiFormNodeLibrary.form} onSubmit={handleSubmit}>
              <FormText label="name" name="name" />
              <FormSubmit text="update" />
            </Form>
          </Card>

          {/* <NodeTags apiForm={apiFormNodeLibrary} /> */}

          <ThumnailAsset nodeID={nodeID} onChange={handleChange} />
        </CardFullHeightScrollY>
      </BreadcrumbView>

      <Route path={`${parentURL}/edit/publishes`}>
        <PublishAssetList nodeID={nodeID} />
      </Route>
    </React.Fragment>
  )
}
